import { FC, Suspense } from 'react';
import { Link as RouterLink } from 'react-router';
import { AppBar, Link, Stack, Toolbar } from '@mui/material';

import { useRouter } from '@cvt/routing';

import config from '@shared/config';

import { Authenticated } from '@modules/Auth/components';

import { useMatchedRoute } from '@shared/hooks/useMatchedRoute';

import { Logo } from './Logo';
import { UserProgress } from './UserProgress';

type Props = {
  onNavigationClickRequest: () => void;
};

export const Header: FC<Props> = () => {

  const router = useRouter();
  const { match } = useMatchedRoute([router.home.path]);

  return (
    <AppBar
      position="fixed"
      color="default"
      variant="outlined"
      sx={{ pt: 'env(safe-area-inset-top)' }}
    >
      <Toolbar disableGutters>
        <Stack direction="row" spacing={2} width="100%" justifyContent="space-between">
          <Stack direction="row" spacing={2} alignItems="center">
            <Link component={RouterLink} to={router.home.path} color="inherit" underline="hover" sx={{ flexGrow: 1 }}>
              <Logo style={{ width: 'auto', height: 30 }} alt={config.projectName}/>
            </Link>
          </Stack>
          
          {!match && (
            <Stack width={200} flexGrow={0} direction="row" alignItems="center" spacing={2}>
              <Authenticated>
                <Suspense>
                  <UserProgress />
                </Suspense>
              </Authenticated>
            </Stack>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};

